export default "__VITE_ASSET__MN8Hb_63__"